module.exports = __webpack_public_path__ + "static/share-bc3714e7d6d9aa8c7002766fe11f526f.jpg";